import React from 'react';
import { SelectionType } from '../enums/SelectionType.enum';
import { useProductSelection } from '../hooks/useProductSelection';
import { ViewProduct } from '../models/ViewProduct.model';
import ColorSwatch from '../product_detail/components/ColorSwatch';
import styles from './ProductColorSwatches.module.scss';

interface Props {
  product: ViewProduct;
  selectionType: SelectionType;
  selectionKey: string;
  isMobile: boolean;
}

export const ProductColorSwatches: React.FC<Props> = ({ product, selectionType, selectionKey, isMobile }) => {
  const { color: selectedColor, setColor: setSelectedColor } = useProductSelection(selectionType, selectionKey);

  if (!product.colors?.length) return <></>;

  return (
    <div className={styles.colorSwatchContainer}>
      {!isMobile && (
        <div>
          <span>COLOR: </span>
          <span className={styles.colorName}>{selectedColor?.toUpperCase()}</span>
        </div>
      )}
      <div className={styles.colorSwatchWrapper}>
        {product.colors.map((c, i) => (
          <ColorSwatch key={i} color={c} active={selectedColor === c} activate={() => setSelectedColor(c)} showSmall={product.colors.length > 8} />
        ))}
      </div>
      {isMobile && (
        <div>
          <span>COLOR: </span>
          <span className={styles.colorName}>{selectedColor?.toUpperCase()}</span>
        </div>
      )}
    </div>
  );
};

export default ProductColorSwatches;
